import { Box } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import LoginForm from '../../components/forms/LoginForm'
import MainLayout from '../../components/MainLayout'
import { AppDispatch } from '../../store'
import authSelectors from '../../store/auth/authSelectors'
import { loginUser } from '../../store/auth/authSlice'

const LoginPage: React.FC = () => {
  const { fulfilled } = useSelector(authSelectors.authState)
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()

  const onSubmit = (data: { [key: string]: string }) => {
    dispatch(loginUser(data as { email: string; password: string }))
  }

  useEffect(() => {
    if (fulfilled) {
      navigate('/cases/inbox', { replace: true })
    }
  }, [fulfilled])

  return (
    <MainLayout className={'t-login-view'}>
      <Box sx={{ maxWidth: '592px', width: '100%' }}>
        <LoginForm onSubmit={onSubmit} />
      </Box>
    </MainLayout>
  )
}

export default LoginPage
